var map = {
	"./dark/callWaiter": [
		85355,
		85355
	],
	"./dark/callWaiter.json": [
		85355,
		85355
	],
	"./dark/failedOrder": [
		42564,
		42564
	],
	"./dark/failedOrder.json": [
		42564,
		42564
	],
	"./dark/guide": [
		77971,
		77971
	],
	"./dark/guide.json": [
		77971,
		77971
	],
	"./dark/historyGuide": [
		425,
		425
	],
	"./dark/historyGuide.json": [
		425,
		425
	],
	"./dark/orderSuccess": [
		17126,
		17126
	],
	"./dark/orderSuccess.json": [
		17126,
		17126
	],
	"./dark/qrCodeError": [
		16367,
		16367
	],
	"./dark/qrCodeError.json": [
		16367,
		16367
	],
	"./dark/smileyDefault": [
		16343,
		16343
	],
	"./dark/smileyDefault.json": [
		16343,
		16343
	],
	"./dark/smileyWithTips": [
		57196,
		57196
	],
	"./dark/smileyWithTips.json": [
		57196,
		57196
	],
	"./light/callWaiter": [
		42403,
		42403
	],
	"./light/callWaiter.json": [
		42403,
		42403
	],
	"./light/failedOrder": [
		40076,
		40076
	],
	"./light/failedOrder.json": [
		40076,
		40076
	],
	"./light/guide": [
		82075,
		82075
	],
	"./light/guide.json": [
		82075,
		82075
	],
	"./light/historyGuide": [
		41793,
		41793
	],
	"./light/historyGuide.json": [
		41793,
		41793
	],
	"./light/orderSuccess": [
		71198,
		71198
	],
	"./light/orderSuccess.json": [
		71198,
		71198
	],
	"./light/qrCodeError": [
		82823,
		82823
	],
	"./light/qrCodeError.json": [
		82823,
		82823
	],
	"./light/smileyDefault": [
		57567,
		57567
	],
	"./light/smileyDefault.json": [
		57567,
		57567
	],
	"./light/smileyWithTips": [
		37540,
		37540
	],
	"./light/smileyWithTips.json": [
		37540,
		37540
	],
	"./loadingAnimation": [
		50290,
		50290
	],
	"./loadingAnimation.json": [
		50290,
		50290
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83781;
module.exports = webpackAsyncContext;